export default __webpack_public_path__ + "b05a46994527e779d3c964a60dfae688.png";